/** @returns {import("stream")} */
const stream = () => window?.nodeModules?.stream;

export default stream;
